import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Asset } from '@api/core';
import { matchText } from '@shared/utils/strings';
import { AssetIconComponent } from '@stillmandigital/assets-icons';
import { isString } from 'lodash';
import { AutocompleteSelectorComponent } from '../autocomplete-selector/autocomplete-selector.component';

@Component({
  selector: 'app-asset-filter',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatPrefix,
    MatSuffix,
    MatLabel,
    MatIcon,
    AssetIconComponent,
    MatAutocomplete,
    MatOption,
    MatIconButton,
    MatInput,
    AsyncPipe,
    MatAutocompleteTrigger,
  ],
  templateUrl: './asset-filter.component.html',
  styleUrl: './asset-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: AssetFilterComponent,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AssetFilterComponent),
      multi: true,
    },
  ],
})
export class AssetFilterComponent extends AutocompleteSelectorComponent<Asset> {
  public matchOption(a: Asset, value: string): boolean {
    return matchText(a.name, value) || matchText(a.code, value);
  }
  public displayOption(asset: string | Asset): string {
    return isString(asset) ? asset : (asset?.code ?? '');
  }
  public extractId(option: Asset | undefined): string | number | undefined {
    return option?.id;
  }
  public label = input<string>('Asset');
}
